/** 用户明确在 Tron 目标下关闭「自定义地址」、改用钱包默认展示时写入，会话内记住 */
const KEY = 'hieswap_tron_receive_prefer_default'

export function getTronPreferDefaultWallet() {
  try {
    return sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function setTronPreferDefaultWallet(on) {
  try {
    if (on) sessionStorage.setItem(KEY, '1')
    else sessionStorage.removeItem(KEY)
  } catch {
    void 0
  }
}

/** 会话内：曾在「目标链为 TRON」且开启自定义接收时置位；用于反向从 TRON 跨出时默认勾选自定义 */
const KEY_DEST_CUSTOM_MIRROR = 'hieswap_tron_dest_custom_mirror'

export function getTronDestCustomMirror() {
  try {
    return sessionStorage.getItem(KEY_DEST_CUSTOM_MIRROR) === '1'
  } catch {
    return false
  }
}

export function setTronDestCustomMirror(on) {
  try {
    if (on) sessionStorage.setItem(KEY_DEST_CUSTOM_MIRROR, '1')
    else sessionStorage.removeItem(KEY_DEST_CUSTOM_MIRROR)
  } catch {
    void 0
  }
}
